import * as React from 'react';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import { visuallyHidden } from '@mui/utils';
import { useNavigate } from 'react-router-dom';
import Service from '../../../../util/Service';
import { AddCircleOutlined, Edit } from '@mui/icons-material';
import SearchField from '../../../util/SearchField';
import { Button } from '@mui/material';
import ConfirmDialog from '../../../common/ConfirmDialog';

const headCells = [
    {
        id: 'name',
        numeric: false,
        disablePadding: true,
        label: 'Nome',
    },
    {
        id: 'login',
        numeric: false,
        disablePadding: true,
        label: 'Login',
    },
    {
        id: 'email',
        numeric: false,
        disablePadding: false,
        label: 'Email',
    }
];

export default function UsuariosTable() {
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [users, setUsers] = React.useState([]);
    const [usersSemFiltro, setUsersSemFiltro] = React.useState([]);
    const [openDelete, setOpenDelete] = React.useState(false);

    const navigate = useNavigate();

    React.useEffect(() => {

        buscaUsers();
    }, []);
    function buscaUsers() {
        Service.GET('/api/security/user/findAll').then(r => {
            setUsers(r);
            setUsersSemFiltro(r);
        });
    }

    function handleFiltro(txt){
        if( !txt || txt.length === 0 ){
            setUsers(usersSemFiltro);
            return;
        }
        console.log( txt )
        console.log(users[0]);
        const arr = usersSemFiltro.filter( u =>{
            if( u.login.indexOf(txt) >=0) return true;
            if( u.nickName && u.nickName.indexOf(txt) >=0) return true;
            if( u.nome && u.nome.indexOf(txt) >=0) return true;
            if( u.email && u.email.indexOf(txt) >=0) return true;
            return false;
        })

        setUsers(arr);
    }

    function handleRemoveUser(){
        console.log( selected )
        Service.GET('/api/security/user/remove/'+selected.id).then(r => buscaUsers());
    }
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleClick = (event, id) => {
        console.log(id)
        if (selected && selected.id === id.id) {
            setSelected(null);
        } else {
            setSelected(id);
            if( selected ){
                console.log( selected.id +"==="+ id.id +"("+(selected.id === id.id)+")" );
            }
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - users.length) : 0;

    const visibleRows = React.useMemo(
        () =>
            [...users]
                .sort(getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
        [order, orderBy, page, rowsPerPage, users],
    );

    function handleDoubleClick(row) {
        navigate('/gerenciar/users/form/' + row.id);
    }
    return (
        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 0 }}>
                <EnhancedTableToolbar user={selected} setOpen={setOpenDelete} filtar={handleFiltro} />
                <TableContainer>
                    <Table
                        sx={{ minWidth: 750 }}
                        aria-labelledby="tableTitle"
                        size={'small'}
                    >
                        <EnhancedTableHead
                            numSelected={selected}
                            order={order}
                            orderBy={orderBy}
                            //onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={users.length}
                        />
                        <TableBody>
                            {visibleRows.map((row, index) => {
                                const isItemSelected = selected && selected.id === row.id;
                                const labelId = `enhanced-table-checkbox-${index}`;

                                return (
                                    <TableRow
                                        hover
                                        onClick={(event) => handleClick(event, row)}
                                        role="checkbox"
                                        aria-checked={isItemSelected}
                                        tabIndex={-1}
                                        key={row.id}
                                        selected={isItemSelected}
                                        sx={{ cursor: 'pointer' }}
                                        onDoubleClick={() => handleDoubleClick(row)}
                                    >
                                        <TableCell padding="normal" sx={{ width: '25ch' }}>
                                            {row.nome}
                                        </TableCell>
                                        <TableCell sx={{ width: '25ch' }}
                                            component="th"
                                            id={labelId}
                                            scope="row"
                                            padding="none"
                                        >
                                            {row.login}
                                        </TableCell>
                                        <TableCell
                                            component="th"
                                            id={labelId}
                                            scope="row"
                                            padding="none"
                                        >
                                            {row.email}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                            {emptyRows > 0 && (
                                <TableRow
                                    style={{
                                        height: (33) * emptyRows,
                                    }}
                                >
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={users.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            
            <ConfirmDialog
                open={openDelete}
                setOpen={setOpenDelete}
                execute={handleRemoveUser}
                ok="Excluir"
                cancel="Sair"
                title="Confirma exclusão?"
                body="Essa confirmação removerá o perfil do usuário dentro do sistema, isso não impedirá o usuário logar no sistema por um provedor de usuários."
            />
        </Box>
    );
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}
function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>

                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

function EnhancedTableToolbar(props) {
    const { user, setOpen, filtar } = props;
    
    return (
        <Toolbar
            sx={[
                {
                    pl: { sm: 2 },
                    pr: { xs: 1, sm: 1 },
                },
                user != null && {
                    bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                },
            ]}
        >
            {user != null ? (
                <Typography
                    variant="subtitle1"
                    component="div"
                    sx={{
                        color: "inherit",
                        flex: '1 1 100%'
                    }}>
                    Gerenciar Colaborador {user.nome}
                </Typography>
            ) : (
                <Typography
                    sx={{ flex: '1 1 100%' }}
                    variant="h6"
                    id="tableTitle"
                    component="div"
                >
                    Gerenciar Colaboradores
                </Typography>
            )}
            {user != null ? (
                <React.Fragment>
                    <Tooltip title="Remover User">
                    <IconButton onClick={() => setOpen(true)}>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Editar">
                    <IconButton>
                        <Edit />
                    </IconButton>
                </Tooltip>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <Button  variant="contained" endIcon={<AddCircleOutlined />} 
                        sx={{mr:4, width:'600px'}}
                        href="/gerenciar/cadastroUser"
                    >
                        Novo Colaborador
                    </Button>
                    <SearchField handleSearch={filtar}/>
                </React.Fragment>
            )}
        </Toolbar>
    );
}
